<template>
  <v-layout row justify-center>
    <v-dialog v-model="viewMorePowerPagesDialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">more</v-icon>
            Power Pages
          </span>
          <v-btn absolute right depressed flat fab small @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            v-model="selected"
            :items="powerPages"
            hide-actions
            class="no-action-table"
            value="domain"
            item-key="domain"
            :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <td>
                <a :href="props.item.url.includes('http') ? props.item.url : 'http://' + props.item.url" target="_blank" title="props.item.from_url" class="a-readmore" v-if="props.item.url"><read-more  more-str="show full URL" :text="props.item.url" link="#" less-str="hide" :max-chars="65"></read-more></a>
              </td>
              <!-- <td class="text-xs-center">
                <span v-if="props.item.change > 0" class="keyword-change green--text">
                  <v-icon class="green--text">arrow_drop_up</v-icon>
                  <span>+{{ props.item.change }}</span>
                </span>
                <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                  <v-icon class="red--text">arrow_drop_down</v-icon>
                  <span>{{ Number(props.item.change.toFixed(2)) }}</span>
                </span>
                <span v-else>-</span>
              </td>
              <td class="text-xs-center">{{ props.item.count }}</td>
              <td class="text-xs-center">{{ props.item.average_rank }}</td> -->
              <td class="text-xs-center">{{ props.item.estimated }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap justify-center class="text-xs-center">
            <v-spacer class="xs-d-none"></v-spacer>
            <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'PowerPagesBoxModal',
  props: ['viewMorePowerPagesDialog', 'powerPages'],
  data () {
    return {
      // testData: {'data': [{'url': 'https://www.goldmarketing.co.il/\u05d1\u05e0\u05d9\u05d9\u05ea-\u05d0\u05ea\u05e8-\u05d0\u05d9\u05e0\u05d8\u05e8\u05e0\u05d8/', 'count': 4, 'change': 0, 'average_rank': 46, 'average_page': 5}, {'url': 'https://www.goldmarketing.co.il/\u05d1\u05e0\u05d9\u05d9\u05ea-\u05d0\u05ea\u05e8\u05d9\u05dd-\u05d1\u05d5\u05d5\u05e8\u05d3\u05e4\u05e8\u05e1/', 'count': 1, 'change': 0, 'average_rank': 66, 'average_page': 7}, {'url': 'https://www.goldmarketing.co.il/seo-\u05e7\u05d9\u05d3\u05d5\u05dd-\u05d0\u05d5\u05e8\u05d2\u05e0\u05d9-\u05e7\u05d9\u05d3\u05d5\u05dd-\u05d0\u05ea\u05e8\u05d9\u05dd-\u05d1\u05d2\u05d5\u05d2\u05dc/', 'count': 1, 'change': 0, 'average_rank': 19, 'average_page': 2}, {'url': 'https://www.goldmarketing.co.il/\u05e1\u05e7\u05d9\u05e8\u05ea-\u05ea\u05d5\u05db\u05e0\u05d9\u05ea-\u05d4\u05e9\u05d5\u05ea\u05e4\u05d9\u05dd-\u05e9\u05dc-booking-com/', 'count': 1, 'change': 0, 'average_rank': 1, 'average_page': 1}, {'url': 'https://www.goldmarketing.co.il/\u05e9\u05d9\u05d5\u05d5\u05e7-\u05e9\u05d5\u05ea\u05e4\u05d9\u05dd-\u05d1\u05d5\u05e7\u05d9\u05e0\u05e7/', 'count': 1, 'change': 1, 'average_rank': 2, 'average_page': 1}, {'url': 'https://www.goldmarketing.co.il/\u05de\u05d5\u05e8\u05d4-\u05e4\u05e8\u05d8\u05d9-\u05dc\u05d0\u05de\u05d6\u05d5\u05df-\u05dc\u05d4\u05e4\u05d5\u05da-\u05dc-seller-\u05d1\u05d0\u05de\u05d6\u05d5\u05df/', 'count': 1, 'change': 0, 'average_rank': 1, 'average_page': 1}, {'url': 'https://www.goldmarketing.co.il/\u05e9\u05d9\u05e2\u05d5\u05e8-\u05e4\u05e8\u05d8\u05d9-\u05d1\u05d0\u05de\u05d6\u05d5\u05df-\u05dc\u05d4\u05e4\u05d5\u05da-\u05dc-seller-\u05d1\u05d0\u05de\u05d6\u05d5\u05df/', 'count': 1, 'change': 0, 'average_rank': 2, 'average_page': 1}], 'last_update': '2020-04-21'},
      selected: [],
      loading: false,
      selectedValue: null,
      headers: [
        { text: 'Pages', value: 'url', sortable: false },
        { text: 'Estimated traffic', value: 'estimated', sortable: false, align: 'middle' }
        // { text: 'Change', value: 'change', sortable: false, align: 'middle' },
        // { text: 'Count', value: 'count', sortable: false, align: 'middle' },
        // { text: 'Average rank', value: 'average_rank', sortable: false, align: 'middle' }
      ]
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    // this.powerPages = this.testData.data
    // if (this.keyword && (this.engineId || this.engineId === 0)) {
    //   this.getPowerPages()
    // }
  },
  // watch: {
  //   'viewMorePowerPagesDialog': function () {
  //     if (this.viewMorePowerPagesDialog && this.project) {
  //       this.getPowerPages()
  //     }
  //   }
  // },
  methods: {
    // downloadXlsx () {
    //   if (!this.$store.state.user.permissions.is_admin && !this.$store.state.user.permissions.download_xlsx) {
    //     this.$eventEmitter.$emit('showAlert', 'perms', 'You have no access to download xlsx file', 'To get access please upgrade your package')
    //   } else {
    //     this.loading = true
    //     this.$store.dispatch('EXPORT_COMPETITORS', { projectId: this.project.id, engineId: parseInt(this.$route.params.engineId) }).then(res => {
    //       this.saveFile(res)
    //       this.loading = false
    //       this.$toasted.show('Download will start in few seconds')
    //     }, err => {
    //       console.log('EXPORT_COMPETITORS ERROR', err)
    //       this.loading = false
    //       let errorText = this.$services.getApiError(err)
    //       if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //     })
    //   }
    // },
    // saveFile (data) {
    //   let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
    //   let link = document.createElement('a')
    //   link.href = window.URL.createObjectURL(blob)
    //   link.download = 'competitors_export.xlsx'
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // },
    // getPowerPages () {
    //   let params = {
    //     top: 25,
    //     engine_id: parseInt(this.$route.params.engineId)
    //   }
    //   this.loading = true
    //   this.$store.dispatch('GET_TOP_COMPETITORS', { projectId: '', params: params }).then(res => {
    //     this.powerPages = res.data
    //     this.selected = this.powerPages.filter(competitor => this.projectCompetitorsDomains.includes(competitor.domain))
    //     this.loading = false
    //   }, err => {
    //     this.loading = false
    //     console.log('GET_TOP_COMPETITORS error', err)
    //     let errorText = this.$services.getApiError(err)
    //     if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //   })
    // },
    closeModal () {
      this.$parent.$emit('viewMorePowerPagesDialog', false)
    }
  }
}
</script>

<style scoped>
.competitors-modal-table thead tr th:first-child, .competitors-modal-table tbody tr td:first-child {
  padding: 0 10px;
  width: 45px;
}
.competitors-modal-table thead tr th, .competitors-modal-table tbody tr td {
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/boxes/PowerPagesBoxModal.vue